module.exports = "/lucky-balls/img/drum/frame.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/frame.png
// module id = 1058
// module chunks = 0